import { createSlice } from "@reduxjs/toolkit";
import { tokenStorage } from "../services/auth/tokenStorage";

type LoggedState = {
    isLoggedIn: boolean
}

const initialState: LoggedState = {
    isLoggedIn: Boolean(tokenStorage.getAccessToken())
}

const loggedInReducer = createSlice({
    name: 'isLoggedIn',
    initialState,
    reducers: {
        logIn: (state) => {
            state.isLoggedIn = true;
        },
        logOut: (state) => {
            state.isLoggedIn = false;
        },
    }
});

export const { logIn, logOut } = loggedInReducer.actions;
export default loggedInReducer.reducer;
